import { ConfigService } from '../../../infra/config'
import { BaseRepository } from '../../../infra/base.repository'
import type { Board } from './board'

export class BoardsRepository extends BaseRepository<Board> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.pipelineApiUrl + '/' + 'boards', token, cache)
    }
}
